import React, { Component } from "react";
import "components/fragments/custom-radio/CustomRadio.scss";

export default class CustomRadio extends Component {
  render() {
    const { label, selected, clickRadio, id, disabled, name, ariaLabel } =
      this.props;

    return (
      <div className={"custom-radio" + (disabled ? "-disabled" : "")}>
        <input
          type="radio"
          name={name}
          id={label}
          value={id}
          checked={selected}
          onChange={disabled ? null : () => clickRadio(id)}
          aria-label={ariaLabel}
        />
        <label
          htmlFor={label}
          className={"custom-radio-label" + (disabled ? "-disabled" : "")}
        >
          <span>{label}</span>
        </label>
      </div>
    );
  }
}
